.divider {
  align-self: stretch;
}

.requiredExperience {
  display: grid;
  gap: var(--spacingMd);
  grid-template-columns: min-content min-content min-content;
  justify-content: center;
  align-items: center;
}

.marginTop {
  margin-top: var(--spacingSm);
}

.title {
  align-self: center;
}

.experienceMissingText {
  width: 90px;
  max-width: 90px;
  text-align: center;
}

.parentChildText {
  width: 250px;
  max-width: 250px;
  text-align: center;
}
